// @ts-nocheck
import { Column } from 'react-table'
import { BalanceInfoCell } from './BalanceInfoCell'
import { BalanceActionsCell } from './BalanceActionsCell'
import { BalanceSelectionCell } from './BalanceSelectionCell'
import { BalanceCustomHeader } from './BalanceCustomHeader'
import { BalanceSelectionHeader } from './BalanceSelectionHeader'
import { Balance } from '../../core/_models'
import { FormattedMessage } from 'react-intl'
import dayjs from 'dayjs'

const balancesColumns: ReadonlyArray<Column<Balance>> = [
  {
    Header: (props) => <BalanceSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <BalanceSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <BalanceCustomHeader
        tableProps={props}
        title={<FormattedMessage id='BALANCE.TABLE.COLUMN.RESELLER' defaultMessage='Reseller' />}
        className='min-w-125px'
      />
    ),
    id: 'reseller_name',
    accessor: (row) => row.reseller?.reseller_name || 'N/A',
  },
  {
    Header: (props) => (
      <BalanceCustomHeader
        tableProps={props}
        title={<FormattedMessage id='BALANCE.TABLE.COLUMN.AMOUNT' defaultMessage='Amount' />}
        className='min-w-100px'
      />
    ),
    id: 'amount',
    accessor: 'amount',
  },
  {
    Header: (props) => (
      <BalanceCustomHeader
        tableProps={props}
        title={<FormattedMessage id='BALANCE.TABLE.COLUMN.CURRENCY' defaultMessage='Currency' />}
        className='min-w-100px'
      />
    ),
    id: 'currency_code',
    accessor: (row) => row.currency?.code || 'N/A',
  },
  {
    Header: (props) => (
      <BalanceCustomHeader
        tableProps={props}
        title={
          <FormattedMessage id='BALANCE.TABLE.COLUMN.REMAINING_BALANCE' defaultMessage='Remaining Balance' />
        }
        className='min-w-125px'
      />
    ),
    id: 'remaining_balance',
    accessor: 'remaining_balance',
  },
  {
    Header: (props) => (
      <BalanceCustomHeader
        tableProps={props}
        title={<FormattedMessage id='BALANCE.TABLE.COLUMN.TYPE' defaultMessage='TYPE' />}
        className='min-w-100px'
      />
    ),
    id: 'transaction_type',
    accessor: 'transaction_type',
    Cell: ({ value }) => {
      const renderStatusBadge = () => {
        switch (value) {
          case 'credit':
            return <span className='badge badge-success'>Credit</span>
          case 'debit':
            return <span className='badge badge-danger'>Debit</span>
          default:
            return <span className='badge badge-light'>{value}</span>
        }
      }
      return renderStatusBadge()
    },
  },
  {
    Header: (props) => (
      <BalanceCustomHeader
        tableProps={props}
        title={<FormattedMessage id='BALANCE.TABLE.COLUMN.DESCRIPTIONS' defaultMessage='Description' />}
        className='min-w-150px'
      />
    ),
    id: 'description',
    accessor: 'description',
  },
  {
    Header: (props) => (
      <BalanceCustomHeader
        tableProps={props}
        title={<FormattedMessage id='BALANCE.TABLE.COLUMN.BALANCEDATE' defaultMessage='Balance Date' />}
        className='min-w-150px'
      />
    ),
    accessor: 'created_at',
    Cell: ({ value }) => <span>{dayjs(value).format('MMMM DD, YYYY')}</span>,
  },
  {
    Header: (props) => (
      <BalanceCustomHeader
        tableProps={props}
        title={<FormattedMessage id='BALANCE.TABLE.COLUMN.STATUS' defaultMessage='Status' />}
        className='min-w-100px'
      />
    ),
    id: 'status',
    accessor: 'status',
    Cell: ({ value }) => {
      const renderStatusBadge = () => {
        switch (value) {
          case 'rollbacked':
            return <span className='badge badge-warning'>Rollbacked</span>
          case 'pending':
            return <span className='badge badge-secondary'>Pending</span>
          default:
            return <span className='badge badge-light'>{value}</span>
        }
      }
      return renderStatusBadge()
    },
  },
  {
    Header: (props) => (
      <BalanceCustomHeader
        tableProps={props}
        title={<FormattedMessage id='TABLE.GENERAL.ACTION' defaultMessage='Action' />}
        className='text-end min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <BalanceActionsCell id={props.data[props.row.index].id} status={props.data[props.row.index].transaction_type} />,
  },
]

export { balancesColumns }
